import { useAccountAuth } from './useAccountAuth';

/**
 * アカウント (master / 担当地区管理者) でログイン中のとき、地区名の横に
 * 「（管理者として利用中）」と表示する小バッジ (地区「強い停止」Phase 1)。
 *
 * 一般の匿名ユーザー (role=null) では何も描画しない (後方互換: 既存ヘッダー見た目を変えない)。
 * AppHome / MapPage / Drawer の地区名表示の隣に置いて使う。内部識別子 (role 'master' 等) は出さず、
 * 一般ユーザーにも分かる日本語ラベルのみ表示する (UI: 内部 key 非表示ルール)。
 *
 * 表示は role を区別せず一律「管理者として利用中」。master / district の差は UI に出さない
 * (要件は「アカウントでログイン中である」ことの可視化であり、権限種別の開示ではないため)。
 */
export function AccountRoleBadge({ className }: { className?: string }) {
  const { state } = useAccountAuth();
  const isAccount = state.status === 'authenticated' && state.role !== null;
  if (!isAccount) return null;
  return (
    <span
      className={`text-[10px] text-primary-700 bg-primary-50 px-1.5 py-0.5 rounded whitespace-nowrap ${className ?? ''}`}
      title="管理者アカウントでログイン中です"
    >
      （管理者として利用中）
    </span>
  );
}
